"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormListPage = exports.FormListPageConfig = void 0;
const icons_1 = require("../components/icon/icons");
const table_1 = require("../components/table/table");
const i18n_1 = require("../i18n");
const form_list_1 = require("../modules/form/form.list");
const services_1 = require("../services");
const index_1 = require("../store/index");
const page_1 = require("./page");
exports.FormListPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.formList,
    path: '/form/list',
    auth: {
        required: true,
    },
    nav: {
        name: i18n_1.T.LIST_FORM_LIST,
        icon: icons_1.MaterialIcon.CONTENT_PASTE,
    },
};
class FormListPage extends page_1.IkePage {
    constructor() {
        super(exports.FormListPageConfig);
        this.component = new form_list_1.FormList();
        index_1.AppStore.FormSummary.refresh();
    }
    get nodes() {
        var _a, _b;
        if (services_1.Services.Department.current == null) {
            return null;
        }
        if (!((_a = services_1.Services.User.current) === null || _a === void 0 ? void 0 : _a.objectId)) {
            return null;
        }
        const userProfile = services_1.Services.UserProfile.get((_b = services_1.Services.User.current) === null || _b === void 0 ? void 0 : _b.objectId);
        if (!userProfile) {
            return null;
        }
        if (!services_1.Services.UserProfile.canEditForms(userProfile)) {
            return table_1.Table.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_MENU_TITLE_PERMISSION), [], []);
        }
        return this.component.view();
    }
}
exports.FormListPage = FormListPage;
//# sourceMappingURL=form.list.page.js.map